<template>
  <form :class="$style.container" @submit.prevent="onSave">
    <div :class="$style.notify">
      <app-icon name="AlertIcon" size="28" :class="$style.notifyIcon" />
      Учтите все помещения, которые есть на доме: жилые, коммерческие и т. д. Помимо действующих, не забудьте добавить
      тарифы из архива — начисления с этими тарифами могут быть в старых начислениях, среди которых также есть
      задолженности.
    </div>
    <vs-input
      class="mb-4 w-full"
      label="Название статьи"
      v-model="article_name"
      :danger="!!errors.article_name"
      :danger-text="errors.article_name"
    />
    <h4>Добавить тарифы в статью</h4>
    <div :class="$style.tariffs">
      <div v-if="!tariffsTree" class="block-loading" />
      <checkbox-tree
        :tree="tariffsTree"
        v-model="tariffs"
        v-else
      />
    </div>
    <div v-if="errors.tariffs" :class="$style.error">{{ errors.tariffs }}</div>

    <div :class="$style.footer">
      <vs-button button="submit" type="border">{{ article ? 'Сохранить' : 'Создать' }}</vs-button>
    </div>
  </form>
</template>

<script>
import mergeCommonErrors from "@/helpers/mergeCommonErrors";
import arrayToIdIndex    from "@/client/helpers/arrayToIdIndex";
import CheckboxTree      from "@/components/CheckboxTree";
import modalContext      from "@/mixins/modalContext";

const sortByPosition = ( g1, g2 ) => g1.position === g2.position ? 0 : g1.position > g2.position ? 1 : -1;

export default {
  name:       "NotifiesCreateArticlePopup",
  mixins:     [modalContext],
  props:      ['article', 'onSubmit'],
  components: { CheckboxTree },
  data() {
    return {
      article_name: this.article ? this.article.article_name : '',
      tariffs:      this.article ? this.article.tariffs.map(t => t.id) : [],
      tariffsTree:  null,
      errors:       {
        name:    null,
        tariffs: null,
      },
    };
  },
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    apartmentTypes() {
      return this.$store.getters['appUser/availableApartmentsTypes'];
    },
  },
  methods:  {
    loadTariffs() {
      const selectedTariffs = this.article ? arrayToIdIndex(this.article.tariffs) : {};

      return Promise.all([
        this.$http.get('tarifs', { params: { buildings_id: this.selectedHouseId } }),
        this.$http.get('tarifs', { params: { buildings_id: this.selectedHouseId, archive: true } }),
      ]).then(( [{ data: tariffs }, { data: archivedTariffs }] ) => {
        tariffs = [...tariffs, ...archivedTariffs];
        const groups = {};
        const groupedTariffs = {};
        tariffs.sort(sortByPosition);
        tariffs.forEach(tariff => {
          const { tarifs_group, apartments_type, is_archive } = tariff;
          if (!tarifs_group) return;
          if (!groupedTariffs[apartments_type]) groupedTariffs[apartments_type] = { archived: {}, active: {} };
          const type = is_archive ? 'archived' : 'active';
          if (!groupedTariffs[apartments_type][type][tarifs_group.id]) groupedTariffs[apartments_type][type][tarifs_group.id] = [];
          groupedTariffs[apartments_type][type][tarifs_group.id].push(tariff);

          if (!groups[tarifs_group.id]) groups[tarifs_group.id] = tarifs_group;
        });

        const sortedGroups = Object.values(groups).sort(sortByPosition);

        const finalTariffs = [];
        this.apartmentTypes.forEach(apartmentType => {
          if (!groupedTariffs[apartmentType.id]) return;

          const apartmentTypeNode = {
            title:      `Тарифы для помещения: ${apartmentType.name}`,
            selectable: false,
            expanded:   true,
            children:   [],
          };

          ['active', 'archived'].forEach(( type ) => {
            sortedGroups.forEach(group => {
              const tariffs = groupedTariffs[apartmentType.id][type][group.id];
              if (!tariffs) return;

              const groupNode = {
                title:      `${group.name}${type === 'archived' ? ' (архив)' : ''}`,
                selectable: true,
                expanded:   true,
                children:   tariffs.map(tariff => ({
                  title:      `${tariff.name}`,
                  value:      tariff.id,
                  selectable: true,
                  selected:   !!selectedTariffs[tariff.id],
                  expanded:   true,
                  children:   [],
                })),
              };

              apartmentTypeNode.children.push(groupNode);
            });
          });

          finalTariffs.push(apartmentTypeNode);
        });
        this.tariffsTree = finalTariffs;
      });
    },

    onSave() {
      const result = this.onSubmit({ article_name: this.article_name, tariffs: this.tariffs });
      if (result && result.then) {
        result.then(
          this.modalResolve,
          ( e ) => {
            const { response: { data: { errors } } } = e;
            this.errors = mergeCommonErrors(errors, ['article_name', 'tariffs']);
            if (this.errors.common) this.$vs.notify({
              color: 'danger',
              time:  10000,
              title: 'Ошибка',
              text:  this.errors.common,
            });
          },
        );
      }

    },
  },
  mounted() {
    this.loadTariffs();
  },
};
</script>

<style lang="scss" module>
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.notify {
  padding-left: 38px;
  position: relative;
  line-height: 1.15;
  margin-bottom: 1em;
}

.notifyIcon {
  position: absolute;
  top: 0;
  left: 0;
  color: color(danger);
}

.footer {
  margin-top: 1em;
  text-align: center;
}

.tariffs {
  flex: 1;
  overflow: auto;
  min-height: 0;
  padding: 15px;
}

.error {
  padding: 2px 4px 4px;
  display: block;
  font-size: .65rem;
  color: rgba(var(--vs-danger), 1);
}
</style>
